import { LCDClient } from '@terra-money/terra.js'
import { APIParams } from '@terra-money/terra.js/dist/client/lcd/APIRequester'
import { constantNetwork, defaultNetworkName } from 'constants/network'

export class BaseLcdService {
  lcdClient: LCDClient

  constructor() {
    const { lcd: URL, chainID } = constantNetwork[defaultNetworkName]
    this.lcdClient = new LCDClient({
      URL,
      chainID,
    })
  }

  initLCD = (lcdClient: LCDClient) => {
    this.lcdClient = lcdClient
  }

  contractQuery = async <T>(
    contractAddress: string,
    query: object,
    params?: APIParams,
  ): Promise<T> => {
    return await this.lcdClient.wasm.contractQuery<T>(
      contractAddress,
      query,
      params,
    )
  }
}

export const baseLcdService = new BaseLcdService()
